"use client"
import React, { useState, useEffect, Fragment } from "react";
import Select, { components } from "react-select";
import { useAppData } from "@/lib/providers/AppDataProvider";
import ProfileTypeIcon from "@/components/shared/ProfileTypeIcon";

import "@/components/communities/CommunityMapPointFilterv2.css";

import * as turf from "@turf/turf";
import ProfileTypeFilter from "@/components/categories/ProfileTypeFilter";
import AmenityFilter from "@/components/categories/AmenityFilter";
import { Form } from "react-bootstrap";
import { useMediaQuery } from "react-responsive";
import TextSearchInputField from "@/components/shared/TextSearchInputField";
import { Collapse } from "react-bootstrap";
import { useEventListener } from "@/lib/events";

var moment = require("moment");

const CommunityMapPointFilterv2 = ({
  points,
  types,
  onSelect,
  placeholder
}) => {
  const isSm = useMediaQuery({ maxWidth: 767.98 });
  const [selected, setSelected] = useState([]);
  const [selectedType, setSelectedType] = useState(null);
  const [selectedSubtype, setSelectedSubtype] = useState(null);
  const [selectedAmenities, setSelectedAmenities] = useState(null);
  const [openNowCheck, setOpenNowCheck] = useState(true);
  const [typeGroupOptions, setTypeGroupOptions] = useState(null);
  const [amenityOptions, setAmenityOptions] = useState(null);
  const { flattenedProfileTypes: profileTypes, profileTypes: nestedProfileTypes, amenities } = useAppData();
  const [filterOptions, setFilterOptions] = useState([]);
  const [typeCounts, setTypeCounts] = useState({
    AMBASSADOR: 0,
    POI: 0,
    BUSINESS: 0,
    COMMUNITY: 0
  });
  const [textSearch, setTextSearch] = useState(null);
  const [showFilterOptions, setShowFilterOptions] = useState(false);
  const [filterActive, setFilterActive] = useState(false);

  const [filterFeature, setFilterFeature] = useState(false);

  const typeToLabel = {
    AMBASSADOR: "Ambassadors",
    BUSINESS: "Businesses",
    POI: "Points of Interest",
    COMMUNITY: "Communities"
  };

  useEffect(() => {
    // console.log(points,types,profileTypes);
    if (points && types && profileTypes) {
      var options = [];

      // const t0 = performance.now();

      var businessProfiles = [];
      var storytellerProfiles = [];
      var poiProfiles = [];
      var communityProfiles = [];

      var usedProfileTypeStrings = [];

      var typeGroupSearchOptions = {};

      points.forEach((point, index) => {
        if (point.type === "USER_PROFILE") {
          var entry = {
            type: "POINT",
            label: point.userProfile.displayName,
            value: point.id
          };

          if (point.userProfile.userProfileType === "BUSINESS") {
            businessProfiles.push(entry);
          } else if (point.userProfile.userProfileType === "POI") {
            poiProfiles.push(entry);
          } else if (point.userProfile.userProfileType === "AMBASSADOR") {
            storytellerProfiles.push(entry);
          } else if (point.userProfile.userProfileType === "COMMUNITY") {
            communityProfiles.push(entry);
          }
          usedProfileTypeStrings = usedProfileTypeStrings.concat(
            point.userProfile.types
          );
        }
      });

      // COUNTS
      setTypeCounts({
        AMBASSADOR: storytellerProfiles.length,
        POI: poiProfiles.length,
        BUSINESS: businessProfiles.length,
        COMMUNITY: communityProfiles.length
      });

      // AMENITIES

      var theAmenities = usedAmenities(points);
      setAmenityOptions(theAmenities.map(am => am.value));
      var amenitySearch = theAmenities.map(function(am, index) {
        return buildOption("USER_PROFILE", am, { by: "AMENITY" });
      });

      // PROFILE TYPES

      var flattenedUsedProfileTypeStrings = [
        ...new Set([].concat([], usedProfileTypeStrings).flat())
      ];

      var usedProfileTypes = profileTypes.filter(pt =>
        flattenedUsedProfileTypeStrings.includes(pt.value)
      );

      var profileTypeSearch = [];

      var usedBusinessGroupTypes = [];
      nestedProfileTypes["BUSINESS"].forEach((group, index) => {
        var usedInGroupProfileTypes = group.options.filter(pt =>
          flattenedUsedProfileTypeStrings.includes(pt.value)
        );
        if (usedInGroupProfileTypes.length > 0) {
          var groupTypeSearch = usedInGroupProfileTypes.map(function(
            pt,
            index
          ) {
            return buildOption("USER_PROFILE", pt, { by: "PROFILE_TYPE" });
          });
          var newGroup = { ...group };
          newGroup.label = `All ${newGroup.label}`;
          groupTypeSearch.unshift(
            buildOption("USER_PROFILE", newGroup, {
              by: "GROUP_TYPE",
              type: newGroup.type
            })
          );
          profileTypeSearch = profileTypeSearch.concat(groupTypeSearch);
          usedBusinessGroupTypes.push(group.value);
        }
      });
      typeGroupSearchOptions["BUSINESS"] = usedBusinessGroupTypes;

      var usedPoiGroupTypes = [];
      nestedProfileTypes["POI"].forEach((group, index) => {
        var usedInGroupProfileTypes = group.options.filter(pt =>
          flattenedUsedProfileTypeStrings.includes(pt.value)
        );
        if (usedInGroupProfileTypes.length > 0) {
          var groupTypeSearch = usedInGroupProfileTypes.map(function(
            pt,
            index
          ) {
            return buildOption("USER_PROFILE", pt, { by: "PROFILE_TYPE" });
          });
          var newGroup = { ...group };
          newGroup.label = `All ${newGroup.label}`;
          groupTypeSearch.unshift(
            buildOption("USER_PROFILE", newGroup, {
              by: "GROUP_TYPE",
              type: newGroup.type
            })
          );
          profileTypeSearch = profileTypeSearch.concat(groupTypeSearch);
          usedPoiGroupTypes.push(group.value);
        }
      });
      typeGroupSearchOptions["POI"] = usedPoiGroupTypes;

      const usedAmbassadorGroupTypes = [];
      nestedProfileTypes["AMBASSADOR"].forEach((group, index) => {
        var usedInGroupProfileTypes = group.options.filter(pt =>
          flattenedUsedProfileTypeStrings.includes(pt.value)
        );
        if (usedInGroupProfileTypes.length > 0) {
          var groupTypeSearch = usedInGroupProfileTypes.map(function(
            pt,
            index
          ) {
            return buildOption("USER_PROFILE", pt, { by: "PROFILE_TYPE" });
          });
          var newGroup = { ...group };
          newGroup.label = `All ${newGroup.label}`;
          groupTypeSearch.unshift(
            buildOption("USER_PROFILE", newGroup, {
              by: "GROUP_TYPE",
              type: newGroup.type
            })
          );
          profileTypeSearch = profileTypeSearch.concat(groupTypeSearch);

          usedAmbassadorGroupTypes.push(group.value);
        }
      });
      typeGroupSearchOptions["AMBASSADOR"] = usedAmbassadorGroupTypes;
      setTypeGroupOptions(typeGroupSearchOptions);

      options = options.concat(profileTypeSearch);

      if (businessProfiles.length > 0) {
        options = options.concat(businessProfiles);
      }
      if (storytellerProfiles.length > 0) {
        options = options.concat(storytellerProfiles);
      }
      if (poiProfiles.length > 0) {
        options = options.concat(poiProfiles);
      }
      if (communityProfiles.length > 0) {
        options = options.concat(communityProfiles);
      }
      if (amenitySearch.length > 0) {
        options = options.concat(amenitySearch);
      }

      setFilterOptions(options);
    }
  }, [points, profileTypes, types]);

  useEffect(() => {
    if (textSearch && textSearch.length > 2) {
      var optionsToReturn = filterOptions.filter(
        opt => opt.label.toLowerCase().indexOf(textSearch.toLowerCase()) > -1
      );
      if (optionsToReturn && optionsToReturn.length > 0) {
        var allResults = optionsToReturn.map(opt => {
          return filterPoints(opt);
        });
        var flattened = [...new Set([].concat([], allResults).flat())];
        onSelect(flattened);
      } else {
        onSelect([]);
      }
    } else {
      onSelect(points);
    }
  }, [textSearch]);

  const usedAmenities = points => {
    var usedAmenityStrings = [];
    points.forEach((point, index) => {
      if (point.type === "USER_PROFILE") {
        usedAmenityStrings = usedAmenityStrings.concat(
          point.userProfile.amenities
        );
      }
    });
    var flattenedUsedAmenityStrings = [
      ...new Set([].concat([], usedAmenityStrings).flat())
    ];
    var usedAmenities = flattenedUsedAmenityStrings.map(val => {
      return amenities.find(am => am.value === val);
    });
    usedAmenities = usedAmenities.filter(am => am != null);
    return usedAmenities;
  };

  const buildOption = (type, category, filter) => {
    return {
      type: type,
      filter: filter,
      label: category.label,
      value:
        filter && filter.by === "AMENITY" ? [category.value] : category.value
    };
  };

  useEffect(() => {
    var filteredPoints = [...points];
    if (filterFeature) {
      var polygon = turf.polygon(filterFeature.feature.geometry.coordinates);
      filteredPoints = filteredPoints.filter(fp => {
        if (fp.location) {
          var pt = turf.point([fp.location.longitude, fp.location.latitude]);
          return turf.booleanPointInPolygon(pt, polygon);
        } else {
          return false;
        }
      });
    }
    if (selectedType) {
      if (selectedSubtype) {
        filteredPoints = filterPoints(
          {
            type: "USER_PROFILE",
            filter: { by: "GROUP_TYPE", type: selectedType },
            value: selectedSubtype
          },
          filteredPoints
        );

        if (selectedAmenities) {
          filteredPoints = filterPoints(
            {
              type: "USER_PROFILE",
              filter: { by: "AMENITY" },
              value: selectedAmenities
            },
            filteredPoints
          );
        } else {
          var theAmenities = usedAmenities(filteredPoints);
          setAmenityOptions(theAmenities.map(am => am.value));
        }
        if (openNowCheck && selectedType === "BUSINESS") {
          filteredPoints = openNowFilter(filteredPoints);
        }
        onSelect(filteredPoints);
      } else {
        filteredPoints = filterPoints(
          {
            type: "USER_PROFILE",
            filter: { by: "USER_PROFILE_TYPE" },
            value: selectedType
          },
          filteredPoints
        );
        if (openNowCheck && selectedType === "BUSINESS") {
          filteredPoints = openNowFilter(filteredPoints);
        }
        onSelect(filteredPoints);
      }
    } else if (filterFeature) {
      onSelect(filteredPoints);
    } else {
      onSelect(null);
    }
    setFilterActive(
      selectedType || selectedSubtype || selectedAmenities || filterFeature
    );
  }, [
    selectedType,
    selectedSubtype,
    selectedAmenities,
    openNowCheck,
    filterFeature
  ]);

  const handleChange = selectedOptions => {
    // commenting this out for now, not sure what this is about
    // setSelected(basic ? selectedOptions : null);
    setSelected(null);
    if (onSelect) {
      if (selectedOptions) {
        onSelect(filterPoints(selectedOptions));
      } else {
        onSelect(null);
      }
    }
  };

  const openNowFilter = filteredPoints => {
    var now = moment();
    return filteredPoints.filter(
      fp =>
        fp.userProfile &&
        fp.userProfile.location &&
        fp.userProfile.location.hours &&
        openNow(now, fp.userProfile.location.hours)
    );
  };

  const openNow = (now, openHours) => {
    var hoursObj = JSON.parse(openHours);
    // get today, time and day
    var utcOffset = moment.parseZone(now).utcOffset();
    var minutes = utcOffset * -1;
    var dow = now.format("dddd");
    var dowCaps = dow.toUpperCase();
    // find the object that contains the day
    // find the object that contains the day
    var dayObject = hoursObj.periods.find(
      period => period.open.day === dowCaps
    );
    if (dayObject && dayObject.open && dayObject.close) {
      // create the day from the name of the day
      var startOfDay = moment()
        .hours(dayObject.open.time.hour)
        .minutes(dayObject.open.time.minute);
      // .add(minutes, "minutes");
      var endOfDay = moment()
        .hours(dayObject.close.time.hour)
        .minutes(dayObject.close.time.minute);
      // .add(minutes, "minutes");
      if (dayObject.open.day !== dayObject.close.day) {
        endOfDay = endOfDay.add(1, "days");
      }
      if (now.isBetween(startOfDay, endOfDay)) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  const filterPoints = (searchFilter, existingFilter) => {
    // console.log("CommunityMapPointFilter filterPoints", searchFilter,existingFilter);
    // STORY, USER_PROFILE, EVENT
    // as an example, {type: "STORY", label: "Parkour", value: "play.outdoors.parkour"}
    // {type: "USER_PROFILE", label: "Cafe", value: "food.cafe"}
    // {type: "EVENT", label: "Literary", value: "cultural.literary"}

    var pointsToFilter = existingFilter ?? points;

    if (searchFilter == null) {
      return null;
    } else {
      if (searchFilter.type === "POINT") {
        return pointsToFilter.filter(point => point.id === searchFilter.value);
      } else {
        var filteredPoints = pointsToFilter.filter(
          point => point.type === searchFilter.type
        );
        if (filteredPoints.length > 0) {
          // console.log(filteredPoints);
          if (searchFilter.type === "USER_PROFILE") {
            if (searchFilter.filter.by === "PROFILE_TYPE") {
              filteredPoints = filteredPoints.filter(
                fp =>
                  fp.userProfile.types.findIndex(
                    typ => typ === searchFilter.value
                  ) > -1
              );
            } else if (searchFilter.filter.by === "AMENITY") {
              filteredPoints = filteredPoints.filter(
                fp =>
                  fp.userProfile.amenities.findIndex(am =>
                    searchFilter.value.includes(am)
                  ) > -1
              );
            } else if (searchFilter.filter.by === "GROUP_TYPE") {
              var group = nestedProfileTypes[searchFilter.filter.type].find(
                gp => gp.value === searchFilter.value
              );
              if (group) {
                var allGroupTypes = group.options.map(opt => opt.value);
                filteredPoints = filteredPoints.filter(
                  fp =>
                    fp.userProfile.types.filter(value =>
                      allGroupTypes.includes(value)
                    ).length > 0
                );
              }
            } else if (searchFilter.filter.by === "USER_PROFILE_TYPE") {
              filteredPoints = filteredPoints.filter(
                fp => fp.userProfile.userProfileType === searchFilter.value
              );
            }
          }
          return filteredPoints;
        }
      }
    }
  };

  const formatGroupLabel = data => (
    <div>
      <h4>{data.label}</h4>
    </div>
  );

  const typeLabel = (type, clickable) => {
    var count = typeCounts[type];

    return (
      <div className={`with-icon ${clickable ? "a" : ""}`}>
        <ProfileTypeIcon type={type} />
        <span>
          {typeToLabel[type]} ({count})
        </span>
      </div>
    );
  };

  const ValueContainer = ({ children, ...props }) => {
    return (
      components.ValueContainer && (
        <components.ValueContainer {...props}>
          {!!children && (
            <span className="material-icons" style={{ color: "#CCCCCC" }}>
              search
            </span>
          )}
          {children}
        </components.ValueContainer>
      )
    );
  };

  const searchFilterStyles = {
    menuPortal: base => ({ ...base, zIndex: 9999 }),
    placeholder: base => ({
      ...base,
      paddingLeft: 24
    }),
    singleValue: base => ({
      ...base,
      paddingLeft: 24
    })
  };

  return (
    <div className="community-map-point-filter-v2">
      <div className="search">
        <div className="select">
          <TextSearchInputField
            onChange={text => setTextSearch(text)}
            placeholder={placeholder ?? "Search Community Map"}
          />
        </div>
        <button
          type="button"
          className="filter a"
          onClick={() => setShowFilterOptions(!showFilterOptions)}
        >
          <span
            className="material-icons"
            style={filterActive ? { color: "#1565C0" } : { color: "#090B0B" }}
          >
            filter_list
          </span>
        </button>
      </div>
      <Collapse in={showFilterOptions}>
        <div className="map-filter-options">
          <div className="type-labels-and-counts">
            {filterFeature && (
              <div className="selected-type">
                <span>{filterFeature.label}</span>
                <span
                  className="material-icons"
                  style={{ cursor: "pointer" }}
                  onClick={() => setFilterFeature(null)}
                >
                  close
                </span>
              </div>
            )}
            {selectedType ? (
              <>
                <div className="selected-type">
                  {typeLabel(selectedType)}
                  <span
                    className="material-icons"
                    style={{ cursor: "pointer" }}
                    onClick={() => setSelectedType(null)}
                  >
                    close
                  </span>
                </div>
                {selectedType && selectedType === "BUSINESS" && (
                  <Form.Check
                    className={openNowCheck ? "checked" : ""}
                    custom="true"
                    type={isSm ? "switch" : "checkbox"}
                    checked={openNowCheck}
                    id="active"
                    name="active"
                    onChange={evt => {
                      var enabled = evt.target.checked;
                      setOpenNowCheck(enabled);
                    }}
                    label="Open Now"
                  />
                )}
                <ProfileTypeFilter
                  values={typeGroupOptions[selectedType]}
                  onChange={selected =>
                    setSelectedSubtype(selected ? selected.value : null)
                  }
                />
              </>
            ) : (
              <>
                {types.map((type, index) => {
                  if (typeCounts[type] > 0) {
                    return (
                      <div
                        style={{ cursor: "pointer" }}
                        onClick={() => setSelectedType(type)}
                      >
                        {typeLabel(type, true)}
                      </div>
                    );
                  } else {
                    return <Fragment key={index}></Fragment>;
                  }
                })}
              </>
            )}
          </div>

          {selectedType && selectedSubtype && amenityOptions.length > 0 && (
            <AmenityFilter
              scrollable={isSm}
              iconSize={isSm ? "lg" : "sm"}
              stacked={isSm}
              values={amenityOptions}
              multiple={true}
              onSelect={selected => setSelectedAmenities(selected)}
            />
          )}
        </div>
      </Collapse>
    </div>
  );
};
export default CommunityMapPointFilterv2;
